/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.reference.be.rpc.PortalRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const ItemLookupInvalidInputTypename = 'com.hubspot.portals.platform.reference.be.rpc.models.ItemLookupInvalidInput';
export const ItemLookupNotFoundTypename = 'com.hubspot.portals.platform.reference.be.rpc.models.ItemLookupNotFound';
export const ItemLookupSuccessTypename = 'com.hubspot.portals.platform.reference.be.rpc.models.ItemLookupSuccess';
export const LoginVerifyErrorInternalResponseTypename = 'com.hubspot.portals.platform.reference.be.rpc.models.LoginVerifyErrorInternalResponse';
export const LoginVerifyErrorUnauthenticatedResponseTypename = 'com.hubspot.portals.platform.reference.be.rpc.models.LoginVerifyErrorUnauthenticatedResponse';
export const LoginVerifySuccessResponseTypename = 'com.hubspot.portals.platform.reference.be.rpc.models.LoginVerifySuccessResponse';
export const PlatformFailureTypename = 'com.hubspot.portals.platform.reference.be.rpc.models.PlatformFailure';
export const UserCheckForbiddenTypename = 'com.hubspot.portals.platform.reference.be.rpc.models.UserCheckForbidden';
export const placeholderMethodRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'placeholderMethod',
  auth: 'external',
  fingerprint: 'ycAIvrze_8cgOfvOGN1AGs9i0kjEFy8C',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const loginVerifyAnnotatedRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'loginVerifyAnnotated',
  auth: 'external',
  fingerprint: 'WbJFA0QKvnxK9x1I5trC6EWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const loginVerifyRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'loginVerify',
  auth: 'external',
  fingerprint: 'WbJFA0QKvnzKG8U34dQOvUWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const authenticatedPortalMethodRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'authenticatedPortalMethod',
  auth: 'external',
  fingerprint: 'St3e4i9NzOwgOfvOGN1AGkWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const dynamicCompanyFetchPortalMethodRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'dynamicCompanyFetchPortalMethod',
  auth: 'external',
  fingerprint: 'St3e4i9NzOz4yhPUZhxSNFcgdARZo-ft',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const dynamicProjectFetchPortalMethodRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'dynamicProjectFetchPortalMethod',
  auth: 'external',
  fingerprint: 'St3e4i9NzOzVX2m61RMQKlcgdARZo-ft',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const dynamicProjectsFetchPortalMethodRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'dynamicProjectsFetchPortalMethod',
  auth: 'external',
  fingerprint: 'St3e4i9NzOyae11wiJzYcEWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updatePreferredLanguageRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'updatePreferredLanguage',
  auth: 'external',
  fingerprint: 'Scti690ti0DEl0ZEms6HPUWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCoursesRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'getCourses',
  auth: 'external',
  fingerprint: 'St3e4i9NzOzwpRnEkDxw60WCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getCourseDetailRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'getCourseDetail',
  auth: 'external',
  fingerprint: 'St3e4i9NzOzMPSSNR7pa8FcgdARZo-ft',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getLessonContentRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'getLessonContent',
  auth: 'external',
  fingerprint: 'St3e4i9NzOwqiaq3xbP6X1cgdARZo-ft',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getMyLearningRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'getMyLearning',
  auth: 'external',
  fingerprint: 'St3e4i9NzOy7RrQ9I0wJikWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const lookupItemRpc = {
  serviceName: 'com.hubspot.portals.platform.reference.be.rpc.PortalRpc',
  rpcName: 'lookupItem',
  auth: 'external',
  fingerprint: '1zKFaYCfVzyc6sR-8JTbBZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};